module.exports = __webpack_public_path__ + "img/my-invoice-unselect.0aa3f66a.svg";